import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ChevronLeft.svg",
  "use": "ChevronLeft.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ChevronLeft.svg\"><path d=\"M38.4256,48.4227a2.0038,2.0038,0,0,1-2.8324,0L20.5707,33.4183a1.9984,1.9984,0,0,1,0-2.8291L35.5932,15.5848a2.0016,2.0016,0,0,1,2.8324,2.829l-13.6064,13.59,13.6064,13.59A1.9981,1.9981,0,0,1,38.4256,48.4227Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol